import { ReactComponent as MoreIcon } from '../../../../assets/svg/kebab.svg';
import Note from './common/note';

const SportsItem = ({ workoutTracker, openMenu }) => {
  return (
    <div className='bg-secondary rounded-2xl p-4 space-y-4'>
      <div className='flex justify-between items-center gap-2'>
        <div className='flex items-center gap-2'>
          <span className='text-white text-xs px-2 py-1 border border-tertiary rounded-full'>
            {workoutTracker.type}
          </span>
          <div className='text-white font-bold line-clamp-1'>
            {workoutTracker.workout}
          </div>
        </div>
        <div className='text-white'>
          <MoreIcon
            className='size-5'
            onClick={openMenu}
          />
        </div>
      </div>
      <Note note={workoutTracker.note} />
      <div className='flex items-center justify-between text-xs'>
        <div className='flex items-center justify-center'>
          <div className='text-white border rounded-full px-2 py-1 bg-accent/20 border-accent/80'>
            {workoutTracker.feeling
              ? workoutTracker.feeling.replaceAll(',', ' ')
              : workoutTracker.level
              ? `Lv. ${workoutTracker.level ?? 1}`
              : ''}
          </div>
        </div>
        <div className='flex items-center justify-center'>
          <div className='text-white border rounded-full px-2 py-1 bg-accent/20 border-accent/80'>
            {workoutTracker.duration
              ? Math.ceil(workoutTracker.duration / 60)
              : 0}{' '}
            min
          </div>
        </div>
      </div>
    </div>
  );
};

export default SportsItem;
